/* eslint-disable no-unused-vars */
import React from 'react';

import { Dashboard as DashboardLayout } from 'layouts';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
} from 'components';

import { makeStyles } from '@mui/styles';

import { FormStepper } from './components';

import styles from './styles';
import { useIntl } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
const useStyle = makeStyles(styles);

function NewChargePro(props) {
  const intl = useIntl();
  const classes = useStyle();
  const params = useParams();
  const { groupId, meterId } = params;

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <PortletLabel
              title={intl.formatMessage({
                id: 'app.chargesCardsPro.addCharge.title',
              })}
            />
          </PortletHeader>
          <PortletContent noPadding>
            <FormStepper meterId={meterId} groupId={groupId} />
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}

export default NewChargePro;
